import './Product.scss';

import cn from 'classnames';
import React, { useRef } from 'react';

import Features from '@/common/components/blocks/Product/Features/Features';
import withPriceAndStock from '@/common/hoc/products/withPriceAndStock';
import {
  ProductDefaultProps,
  ProductPropTypes,
} from '@/ebat/components/blocks/ScanSelfService/Product/Product.proptypes';
import ProductDetail from '@/ebat/components/blocks/ScanSelfService/Product/ProductDetail/ProductDetail';

const Product = (props) => {
  const {
    brand,
    className,
    code,
    complementaryDescription,
    details,
    discountClasses,
    discountPrice,
    image,
    invoiceUnit,
    manufacturerSku,
    name,
    publicPrice,
    range,
    saleUnit,
    salesPackaging,
    sku,
    taxRate,
  } = props;

  const contentRef = useRef(null);

  return (
    <div className={cn('self-product', className)} ref={contentRef}>
      <ProductDetail
        brand={brand}
        className="self-product__product-detail"
        code={code}
        complementaryDescription={complementaryDescription}
        discountClasses={discountClasses}
        discountPrice={discountPrice}
        image={image}
        invoiceUnit={invoiceUnit}
        manufacturerSku={manufacturerSku}
        name={name}
        publicPrice={publicPrice}
        range={range}
        saleUnit={saleUnit}
        salesPackaging={salesPackaging}
        sku={sku}
        taxRate={taxRate}
      />
      <Features className="self-product__features" details={details} />
    </div>
  );
};

Product.defaultProps = {
  ...ProductDefaultProps,
};

Product.propTypes = {
  ...ProductPropTypes,
};

export default withPriceAndStock(Product);
